<script>
    export let show = false;
    export let db_name = "raw_data";
    export let collection_name;
    export let old_data = {};
    export let data = {};
    export let fields;
    let loading = false;

    $: isEdit = "_id" in old_data;
    $: title = isEdit ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล";

    import Modal from "../components/Modal.svelte";
    import { getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../api/client.js";
    import OrganizationDropDown from "../components/OrganizationDropDown.svelte";
    import { createEventDispatcher } from "svelte";
    import SimpleTags from "../components/SimpleTags.svelte";
    const context = getContext(api_info);
    const dispatch = createEventDispatcher();

    async function add() {
        loading = true;
        const response = await fetchWithAuthentication(
            context,
            "/add_record/",
            {
                db_name,
                collection_name,
                data,
            }
        );
        if (response.status === true) {
            alert(`เพิ่มข้อมูลเรียบร้อยแล้ว`);
            close();
            dispatch("add_success");
        } else {
            alert("ไม่สามารถเพิ่มข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
        }
        loading = false;
    }
    async function edit() {
        try {
            loading = true;
            const response = await fetchWithAuthentication(
                context,
                "/edit_record/",
                {
                    db_name,
                    collection_name,
                    old_data,
                    new_data: data,
                }
            );
            if (response.status === true) {
                alert("แก้ไขข้อมูลเรียบร้อย");
                close();
                dispatch("edit_success", {
                    data: {
                        ...data,
                        _id: old_data._id,
                    },
                });
            }
        } catch (e) {
            alert("ไม่สามารถแก้ไขข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
        } finally {
            loading = false;
        }
    }
    function close() {
        show = false;
    }
</script>

<Modal {show} {title} additionalClass="modal-lg">
    <form class="form-horizontal">
        {#each fields as field}
            <div class="form-group">
                <label for={field} class="col-sm-3 control-label">{field}</label
                >
                <div class="col-sm-9">
                    {#if field === "detail"}
                        <textarea
                            class="form-control"
                            id={field}
                            rows="8"
                            bind:value={data[field]}
                        />
                    {:else if field === "type_name"}
                        <OrganizationDropDown
                            bind:value={data[field]}
                            id={field}
                        />
                    {:else if field === "tags"}
                        <SimpleTags
                            bind:tags={data[field]}
                            id={field}
                            dragDisabled={true}
                            allowAdd={true}
                        />
                    {:else}
                        <input
                            type="text"
                            class="form-control"
                            id={field}
                            bind:value={data[field]}
                        />
                    {/if}
                </div>
            </div>
        {/each}
    </form>

    <div slot="footer">
        {#if isEdit}
            <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                disabled={loading}
                on:click={edit}
            >
                {#if loading}
                    <span class="glyphicon glyphicon-refresh spinning" />
                {/if}
                แก้ไข</button
            >
        {:else}
            <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
                disabled={loading}
                on:click={add}
            >
                {#if loading}
                    <span class="glyphicon glyphicon-refresh spinning" />
                {/if}เพิ่มข้อมูล</button
            >
        {/if}
        <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            on:click={close}>ยกเลิก</button
        >
    </div>
</Modal>
